import React, { useState, useEffect } from 'react';
import "./Nav.css";

function Nav() {
    //the below piece of code is listening to the scroll and if the scroll is more than 100px down, then show the bar(handleShow)
    //before we fire off the userEFfect again then remove the event listener, so that we don't get like 20 listeners
    
    const [show, handleShow] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                handleShow(true);
            } else {
                handleShow(false);
            } 
        });
        return () => {
            window.removeEventListener("scroll");
        }
    }, []);
   

    return (
        <div className={`nav ${show && "nav__black"}`}>   
            <img
                className="nav__logo"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Netflix_2015_logo.svg/799px-Netflix_2015_logo.svg.png"
                alt="Netflix Logo"
            />

            <img
                className="nav__avatar"
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRmX1IYrleu5pZkTWvD6cBrp4E0knysir8f-A&usqp=CAU"
                alt="Netflix Logo"
            />
        </div>
    );
}

export default Nav;
